import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable consistent-return */
import _isEmpty from 'lodash/isEmpty';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// utils
import { validate as ruleValidator } from '@tekion/tekion-base/utils/ruleValidator';
import { getFormErrors } from '../../organisms/FormBuilder/utils/general';
export var getErrors = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rules, updatedValues, prevErrors) {
    var promisesByFieldId, errors;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          promisesByFieldId = ruleValidator(updatedValues, updatedValues, rules, {
            shouldValidatedOnValues: true
          });
          if (!_isEmpty(promisesByFieldId)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", undefined);
        case 3:
          _context.next = 5;
          return getFormErrors(promisesByFieldId, prevErrors);
        case 5:
          errors = _context.sent;
          return _context.abrupt("return", errors);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getErrors(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Default value state setter which just sets the value for the field in the state
 * without affecting the rest of the state fields.
 * @param {Object} args: These contain the getState and setState method and also the action payload which contains the data of the changed field.
 */
export var defaultOnChangeHandler = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var getState, setState, _ref2$params, params, _getState, currentValueState, shouldAvoidFieldValidation, rules, prevErrors, updatedValues, updatedState, errors;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          getState = _ref2.getState, setState = _ref2.setState, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? EMPTY_OBJECT : _ref2$params;
          _getState = getState(), currentValueState = _getState.values, shouldAvoidFieldValidation = _getState.shouldAvoidFieldValidation, rules = _getState.rules, prevErrors = _getState.errors;
          updatedValues = _objectSpread(_objectSpread({}, currentValueState), {}, _defineProperty({}, params.id, params.value));
          if (shouldAvoidFieldValidation) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", setState({
            values: updatedValues
          }));
        case 5:
          updatedState = {
            values: updatedValues
          };
          setState(updatedState);
          if (!rules) {
            _context2.next = 12;
            break;
          }
          _context2.next = 10;
          return getErrors(rules, updatedValues, prevErrors);
        case 10:
          errors = _context2.sent;
          setState({
            errors: errors
          });
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function defaultOnChangeHandler(_x4) {
    return _ref3.apply(this, arguments);
  };
}();